/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Property } from '@app/shared/components/property/property.model';

@Component({
  selector: 'app-property',
  templateUrl: './property.component.html',
  styleUrls: ['./property.component.scss'],
})
export class PropertyComponent implements OnInit {
  @Input() parentFormGroup: FormGroup;
  @Input() title: string = null;

  /**
   *  Условно валидира properties за company-тата
   *  Ако едно от полетата е попълнено и другото/ите трябва да са попълнени, за да мине валидацията
   *  Пример  type='some type' , value='' // valid:false
   *  Пример  type='' , value='some value' // valid:false
   *  Пример  type='some type' , value='some value' // valid:true
   *  --ВАЖНО--
   *  За момента има само две полета type и value. Ако станат повече тази функция трябва да се допише
   *  ресурси: https://www.codementor.io/jimohhadi/angular-validators-with-conditional-validation-in-reactive-forms-pj5z7gsq5
   */
  public static setCompanyPropertiesValidators(property: FormGroup): FormGroup {
    const valueFormControl = property.get('value');
    const typeFormControl = property.get('type_id');

    valueFormControl.valueChanges.subscribe((val: string) => {
      if (val !== '' && typeFormControl.validator === null) {
        typeFormControl.setValidators([Validators.required]);
        typeFormControl.updateValueAndValidity();
      } else if (val === '' && typeFormControl.validator !== null) {
        typeFormControl.clearValidators();
        typeFormControl.updateValueAndValidity();
      }
    });

    typeFormControl.valueChanges.subscribe((type: string) => {
      if (type && valueFormControl.validator === null) {
        valueFormControl.setValidators([Validators.required]);
        valueFormControl.updateValueAndValidity();
      } else if (type === null && valueFormControl.validator !== null) {
        valueFormControl.clearValidators();
        valueFormControl.updateValueAndValidity();
      }
    });

    return property;
  }

  public static create(): FormGroup {
    const prop = new FormGroup({
      id: new FormControl(null),
      type_id: new FormControl(null),
      value: new FormControl(''),
    });
    return PropertyComponent.setCompanyPropertiesValidators(prop);
  }

  public static createMany(properties: Array<Property>): FormArray {
    const formArray: FormArray = new FormArray([]);
    properties.forEach((property: Property) => {
      formArray.push(PropertyComponent.create());
    });
    return formArray;
  }

  constructor() {}

  ngOnInit() {
    setTimeout(() => {
      // @ts-ignore
      if (this.parentFormGroup.get('properties').length <= 0) {
        this.addProperty();
      }
    });
  }

  addProperty() {
    // @ts-ignore
    this.parentFormGroup.get('properties').push(PropertyComponent.create());
  }

  removeProperty(index: number) {
    this.parentFormGroup.get('properties')['controls'].splice(index, 1);
    this.parentFormGroup.get('properties').updateValueAndValidity();
  }
}
